import { useApiClient } from "@myplant-io/utils/api";
import { useMutation, useQueryClient } from "react-query";

export function useConversationFavorite() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation(
    (id: string) =>
      client.fetch(`/api/history/conversation/${id}/favorite`, {
        method: "PUT",
      }),
    {
      async onSettled() {
        await queryClient.invalidateQueries({
          queryKey: ["conversation"],
        });
      },
    }
  );
}
